// https://bluzky.github.io/nice-select2/
const NICESELECT = {
    onReady() {
        let niceSelects = document.querySelectorAll('.nice-select:not(.assigned)');
        niceSelects.forEach(select => {
            select.classList.add('assigned');
            NiceSelect.bind(select);
        });
    }
}